import { render, staticRenderFns } from "./termManager.vue?vue&type=template&id=c3e264ce&scoped=true"
import script from "./termManager.vue?vue&type=script&lang=js"
export * from "./termManager.vue?vue&type=script&lang=js"
import style0 from "./termManager.vue?vue&type=style&index=0&id=c3e264ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e264ce",
  null
  
)

export default component.exports